// src/core/date.ts

export function isoMinusDays(iso: string, days: number): string {
  const [y, m, d] = iso.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  date.setUTCDate(date.getUTCDate() - days);
  const yy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

const ARCHIVE_DAYS = 7;

export function archiveDates(todayIso: string): string[] {
  const dates: string[] = [];
  for (let i = 1; i <= ARCHIVE_DAYS; i++) {
    dates.push(isoMinusDays(todayIso, i));
  }
  return dates;
}

export function isArchiveUnlocked(
  lastPlayed: string | null,
  todayIso: string,
  todayResultsLen: number,
  todayTotal: number | undefined,
): boolean {
  return lastPlayed === todayIso && todayResultsLen === 5 && todayTotal !== undefined;
}

export function isValidArchiveDate(iso: string, todayIso: string): boolean {
  const valid = archiveDates(todayIso);
  return valid.includes(iso);
}
